import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ProfileMenu } from '../../dropdown/profilemenu/profilemenu.component';
import { UiButtonComponent } from '../../button/button.component';
import { MatIconModule } from '@angular/material/icon';
import { ButtonModule } from 'primeng/button';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SettingService } from '../../../services/setting/setting.service';
import { AppService } from '../../../core/app.service';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [ProfileMenu, MatIconModule, ButtonModule, UiButtonComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  pageTitle = '';

  @Input() collapsed = false;
  @Input() sidebarOpen = false;

  @Output() toggleSidebar = new EventEmitter<void>();

  private _headerBg: string | null = null;

  @Input()
  set headerBg(value: string | null) {
    this._headerBg = value;
    try {
      if (value) {
        document.documentElement.style.setProperty('--app-header-bg', value);
      } else {
        document.documentElement.style.removeProperty('--app-header-bg');
      }
    } catch (e) {
      // ignore when running in non-browser environments
    }
  }

  get headerBg(): string | null {
    return this._headerBg;
  }

brandSigle = 'SAMB'; // fallback si pas encore configuré
brandNomComplet: string | null = null;

constructor(private router: Router, private settingService: SettingService, private appService: AppService) {}

ngOnInit(): void {
  this.updateTitle();
  this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => this.updateTitle());

  const appId = this.appService.getAppId();
  this.settingService.getSystemBrand(appId).subscribe((data) => {
    const sigle = data?.listeDetailsParametres?.find(d => d.code === 'SIGLE')?.valeurAN;
    const nomComplet = data?.listeDetailsParametres?.find(d => d.code === 'NOM_COMPLET')?.valeurAN;
    if (sigle) this.brandSigle = sigle;
    if (nomComplet) this.brandNomComplet = nomComplet;
  });
}

  private updateTitle(): void {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild) { route = route.firstChild; }
    this.pageTitle = route.data?.['title'] ?? '';
  }

  emitToggle(): void {
    this.toggleSidebar.emit();
  }
}